import { MetadataMap } from "./metadata-map";
import { getEntityPrototypeChain } from "./utils";
const RELATIONSHIPS_MAP = new MetadataMap();
const DefaultRelationshipOptions = {
    allowUnresolvedIdentifiers: false,
};
export function relationship(options) {
    const opts = Object.assign({}, DefaultRelationshipOptions, options || {});
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target, key) => {
        RELATIONSHIPS_MAP.setMetadataByType(target.constructor, key, {
            name: key,
            ...opts,
        });
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function getRelationshipMetadata(target) {
    return getEntityPrototypeChain(target).reduce((soFar, prototype) => Object.assign(soFar, RELATIONSHIPS_MAP.getMetadataByType(prototype)), {});
}
